module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/gear-2fcd70447a7c122514278879557a59d7.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/gear.svg
// module id = OaFc
// module chunks = 24